import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import PhotoGrid from '../components/PhotoGrid';
import { galleryPhotos } from '../data/gallery';
import { about, whatWeDo, site, featurePhoto } from '../data/site';

// Ten tiles spread evenly across the album rather than ten consecutive ones,
// so the grid samples the whole festival instead of a few minutes of it.
const ABOUT_TILES = 10;
const candidates = galleryPhotos.filter((p) => p.file !== featurePhoto);
const stride = Math.max(1, Math.floor(candidates.length / ABOUT_TILES));
const aboutPhotos = Array.from({ length: ABOUT_TILES }, (_, i) => candidates[i * stride]).filter(
  Boolean
);

const About: React.FC = () => (
  <>
    <section className="section">
      <Container>
        <div className="text-center">
          <h1 className="section-title">About Art on the Lake</h1>
          <hr className="section-rule" />
        </div>

        <Row className="justify-content-center">
          <Col lg={8}>
            <p className="lede">{about.lede}</p>
            <p>{about.body}</p>
          </Col>
        </Row>
      </Container>
    </section>

    <section className="section bg-water-soft">
      <Container>
        <div className="text-center">
          <h2 className="section-title">What we do</h2>
          <hr className="section-rule" />
        </div>
        <Row className="g-4 justify-content-center">
          {whatWeDo.map((item) => (
            <Col md={6} lg={5} key={item}>
              <div className="h-100 bg-white p-4 shadow-sm">
                <p className="mb-0">{item}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>

    <section className="section">
      <Container>
        <div className="text-center mb-4">
          <h2 className="section-title">Scenes from the festival</h2>
          <hr className="section-rule" />
        </div>
        <PhotoGrid photos={aboutPhotos} />
        <div className="text-center mt-4">
          <Link to="/gallery" className="btn btn-secondary px-4">View the full gallery</Link>
        </div>
      </Container>
    </section>

    <section className="section bg-navy text-white text-center">
      <Container>
        <h2 className="section-title text-white">Get in touch</h2>
        <hr className="section-rule" />
        <p className="mb-4">
          Email <a href={`mailto:${site.email}`} className="text-water">{site.email}</a> or call{' '}
          <a href={site.phoneHref} className="text-water">{site.phone}</a>.
        </p>
        <Link to="/contact" className="btn btn-primary px-4">Contact us</Link>
      </Container>
    </section>
  </>
);

export default About;
